/**
 * @generated SignedSource<<9cb03ce3603747e005fed40410996537>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalIntegrations_person$data = {
  readonly harvestUser: boolean | null;
  readonly unit4User: boolean | null;
  readonly " $fragmentType": "TimeRegistrationModalIntegrations_person";
};
export type TimeRegistrationModalIntegrations_person$key = {
  readonly " $data"?: TimeRegistrationModalIntegrations_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeRegistrationModalIntegrations_person">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalIntegrations_person",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4User",
      "storageKey": null
    }
  ],
  "type": "Person",
  "abstractKey": null
};

(node as any).hash = "d86a4a2e47e87916081608b32d729f5c";

export default node;
